import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class PurchaseDatePeriodInAccountancyWarning extends Violation {
    public constructor() {
        super(ViolationSeverity.Warning, 'business.document.purchase.validation.date-period-in-accountancy-warning.message');
    }
}
